import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { register } from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';
import OAuthButtons from '../components/OAuthButtons';
import '../styles/Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    firstName: '',
    lastName: '',
  });
  const [validation, setValidation] = useState({
    username: '',
    email: '',
    password: ''
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector(state => state.auth);

  const validateUsername = (username) => {
    if (!username) {
      setValidation(prev => ({ ...prev, username: '' }));
      return;
    }
    if (username.length < 3) {
      setValidation(prev => ({ ...prev, username: '❌ Минимум 3 символа' }));
    } else {
      setValidation(prev => ({ ...prev, username: '✅ Хорошо' }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'username') {
      validateUsername(value);
    }
  };

  const canSubmit = formData.username.length >= 3 && formData.email && formData.password && formData.firstName;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) {
      alert('Пожалуйста, заполните все поля корректно');
      return;
    }
    const result = await dispatch(register(formData));
    if (result.payload) {
      navigate('/');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Регистрация</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <input
              type="text"
              name="username"
              placeholder="Имя пользователя (мин. 3 символа)"
              value={formData.username}
              onChange={handleChange}
              required
            />
            {validation.username && (
              <div style={{ fontSize: '0.85rem', marginTop: '0.3rem', color: validation.username.includes('✅') ? '#1dd1a1' : '#ff6b6b' }}>
                {validation.username}
              </div>
            )}
          </div>
          <input
            type="email"
            name="email"
            placeholder="Электронная почта"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Пароль"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="firstName"
            placeholder="Имя"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="lastName"
            placeholder="Фамилия"
            value={formData.lastName}
            onChange={handleChange}
          />
          <button className="submit-btn" type="submit" disabled={loading || !canSubmit}>
            {loading ? 'Регистрация...' : 'Зарегистрироваться'}
          </button>
        </form>

        <OAuthButtons />

        <div className="auth-link">
          <p>Уже есть аккаунт? <a href="/login">Войти</a></p>
        </div>
      </div>
    </div>
  );
};

export default Register;
